import EndpointsBase from "../EndpointsBase";
import BoxLookupConstants from "./Constants";

class BoxLookupEndpoints extends EndpointsBase {
  getBox(
    valueOrigin: number,
    lookupValue: string,
    type?: number,
    workstationID?: number,
    operatorID?: number
  ): Promise<any> | { notFound: boolean } {
    const method = ((valueOrigin, lookupValue, type) => {
      switch (valueOrigin) {
        case BoxLookupConstants.LookupValueOrigin.ScannedBarcode:
          return `box/2d/${lookupValue}`;
        case BoxLookupConstants.LookupValueOrigin.Data:
          return `box/input/${lookupValue}/${type}`;
        default:
          return void 0;
      }
    })(valueOrigin, lookupValue, type);

    if (method === void 0) {
      return { notFound: true }; // Might need to revisit this later, I am trying to represent an empty.
    }

    const request = {
      method: method,
      headers: this._getAuthHeader(operatorID, workstationID),
      run: this.server.get,
    };

    return this._sendRequest(request);
  }
}

export default new BoxLookupEndpoints();
